module.exports = __webpack_public_path__ + "media/images/riders/small/MATTHIAS_STRINEMANN-03296d9fbb0e1b737eed4dc968093613.png";